import { createContext } from "react";
import { IAuthContext } from "../../types/AuthState";

const defaultState: IAuthContext = {
  user: null,
  error: null,
  token: null,
  credential: null,
};

const AuthContext = createContext<IAuthContext>(defaultState);

export default AuthContext;
